import React from "react";

export type SpotPosition = {
    symbol: string;
    qty: number;
    avgEntry: number | null;
    currentPrice: number | null;
    unrealizedPnl: number;
    roe: number;
    realizedPnl: number;
};

type SpotPositionsProps = {
    positions: SpotPosition[];
};

export const SpotPositionsBlock: React.FC<SpotPositionsProps> = ({ positions }) => {
    const openPositions = positions.filter(p => p.qty > 0);

    return (
        <div className="bg-white shadow rounded-xl p-6 border border-gray-200">
            <h2 className="text-xl font-semibold mb-4">Открытые позиции (SPOT)</h2>

            {openPositions.length === 0 ? (
                <div className="text-gray-500 text-sm">Нет открытых позиций</div>
            ) : (
                <div className="overflow-x-auto">
                    <table className="min-w-full text-sm">
                        <thead>
                            <tr className="border-b bg-gray-50">
                                <th className="py-3 px-2 text-left">Пара</th>
                                <th className="py-3 px-2 text-left">Объём</th>
                                <th className="py-3 px-2 text-left">Средняя цена</th>
                                <th className="py-3 px-2 text-left">Текущая цена</th>
                                <th className="py-3 px-2 text-left">PNL</th>
                                <th className="py-3 px-2 text-left">ROE</th>
                            </tr>
                        </thead>

                        <tbody>
                            {openPositions.map((p, i) => (
                                <tr key={i} className="border-b">

                                    <td className="py-2 px-2 font-medium">{p.symbol}</td>
                                    <td className="py-2 px-2">{p.qty.toFixed(6)}</td>
                                    <td className="py-2 px-2">{p.avgEntry?.toFixed(4)}</td>
                                    <td className="py-2 px-2">{p.currentPrice?.toFixed(4)}</td>

                                    <td className={`py-2 px-2 font-semibold ${p.unrealizedPnl >= 0 ? "text-green-600" : "text-red-600"
                                        }`}>
                                        {p.unrealizedPnl.toFixed(4)}
                                    </td>

                                    <td className={`py-2 px-2 font-semibold ${p.roe >= 0 ? "text-green-600" : "text-red-600"
                                        }`}>
                                        {p.roe.toFixed(2)}%
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};